import React from 'react';

import { FormikHelpers } from 'formik';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import SignUpCompleted from './components/SignUpCompleted';
import SignUpForm from './components/SignUpForm';
import { SignUpContentStyled, SignUpWrapperStyled } from './styles';
import { IRegistrationForm } from './types';
import { sendRegistration } from '../../api/security';
import SecurityHeader from '../../components/SecurityHeader';

const SignUp = React.memo(() => {
  const [isProcess, setProcess] = React.useState(false);
  const [isCompleted, setCompleted] = React.useState(false);

  const { t } = useTranslation();

  const onSubmit = React.useCallback(
    async (values: IRegistrationForm, helpers: FormikHelpers<any>) => {
      setProcess(true);

      try {
        const { status } = await sendRegistration(values);

        if (status) {
          helpers.resetForm();

          setCompleted(true);
        }
      } catch (error) {
        if (error instanceof Error) {
          toast.error(t(error.message));
        } else {
          toast.error(t('general.error'));
        }
      } finally {
        setProcess(false);
      }
    },
    [t, setCompleted],
  );

  return (
    <SignUpWrapperStyled width="100%">
      <SecurityHeader color="primary" />

      <SignUpContentStyled>
        {isCompleted && <SignUpCompleted />}

        {!isCompleted && <SignUpForm isProcess={isProcess} onSubmit={onSubmit} />}
      </SignUpContentStyled>
    </SignUpWrapperStyled>
  );
});

export default SignUp;
